import { useMemo } from 'react'
import {
  useGetCustomFieldsOnMount,
  useSelectCustomFieldData,
} from '@user/store/customFields'
import { useGetCustomFieldsSettingsOnMount } from '@user/store/customFieldSettings'
import { ENTITY_TYPES } from '@sales-center/common'

type Props = {
  entityType: ENTITY_TYPES
}

export function useData(props: Props) {
  const { entityType } = props
  const customFieldsLoading = useGetCustomFieldsOnMount()
  const customFieldsSettingsLoading =
    useGetCustomFieldsSettingsOnMount(entityType)

  const { orderedCustomFields, customSettings } = useSelectCustomFieldData()

  const requiredCustomFieldsIds = useMemo(
    () => customSettings.filter((x) => x.required).map((x) => x.customFieldId),
    [customSettings],
  )

  const requiredCustomFields = useMemo(
    () =>
      orderedCustomFields.filter(
        (x) => requiredCustomFieldsIds.indexOf(x.id) >= 0,
      ),
    [orderedCustomFields, requiredCustomFieldsIds],
  )

  return {
    customFieldsLoading,
    customFieldsSettingsLoading,
    customSettings,
    requiredCustomFields,
  } as const
}
